import angular from 'angular'

import { once, inRange, uniqueId } from 'lodash-es'
import { makeOR, isEmpty, defaultTo, zeroIfNaN } from '../../utils/bits'

import envRaw from '../../utils/env-raw'
import Emitter from '../../utils/emitter'
import StrictObj from '../../utils/strict-obj'
import attachGetters from '../../utils/attach-getters'

import { defineGetters } from '../../utils/define-getter'

import Template from './gallery-broken.component.ejs'
import UNKNOWN_ICON from '../../../img/unknown-marker.svg'

angular
  .module('ggs.gallery-broken')
  .component('ggsGalleryBroken', {
    template: Template(StrictObj({
      LE: envRaw.liveEditMode,
      UNKNOWN_ICON
    })),
    controller: GalleryBrokenComponent,
    bindings: {
      ggsPost: '<',
      ggsMedia: '<',
      ggsContentReadyHandler: '<',
      ggsContentAttachCallback: '<'
    }
  })

const SIZE_404 = StrictObj({ width: 404, height: 404 })

function GalleryBrokenComponent(
  qh,
  $scope,
  debugObj,
  imgQueue,
  DefineMethod,
  DefineHandler) {

  const $ctrl = $scope.$ctrl = attachGetters(StrictObj(this))
  const sign = `galleryBroken[id=${$ctrl.ggsPost.id}][mi=${$ctrl.ggsMedia.media_index}][uid=${uniqueId()}]`
  debugObj(sign, $ctrl)

  $ctrl.wrapM = DefineMethod(sign)
  $ctrl.wrapH = DefineHandler(sign)

  $ctrl.contentSizeEmitter = Emitter(`${sign}:contentSize`)
  $ctrl.contentSize = undefined

  $ctrl.thumbSize = imgQueue.lookup($ctrl.ggsMedia.file_thumb)
  $ctrl.thumbFailed = isEmpty($ctrl.ggsMedia.file_thumb)

  defineGetters($ctrl, {
    ready: makeOR(
      $ctrl.getters.thumbFailed,
      $ctrl.getters.thumbSize.terminate)
  })

  // wrappers

  $ctrl.wrapM('callContentReadyHandler',
    qh.makeIf(
      $ctrl.getters.ready,
      once($ctrl.ggsContentReadyHandler)))

  // $onInit

  $ctrl.wrapM('attachToParent', () => {
    return $ctrl.ggsContentAttachCallback(
      $ctrl.extContentCalcWidth,
      $ctrl.extContentCalcHeight,
      $ctrl.extContentApplySize)
  })

  $ctrl.wrapH('$onInit',
    qh.makeJoin(
      $ctrl.attachToParent,
      $ctrl.callContentReadyHandler))

  // $onDestroy

  $ctrl.wrapH('$onDestroy', () => {
    debugObj.remove($ctrl)
  })

  // <ggs-gallery-modal/>

  $ctrl.extContentCalcWidth = (showcaseHeight) => {
    const sourceSize = defaultTo($ctrl.thumbSize, SIZE_404)
    return zeroIfNaN((sourceSize.width / sourceSize.height) * showcaseHeight)
  }

  $ctrl.extContentCalcHeight = (showcaseWidth) => {
    const sourceSize = defaultTo($ctrl.thumbSize, SIZE_404)
    return zeroIfNaN((sourceSize.height / sourceSize.width) * showcaseWidth)
  }

  $ctrl.wrapM('extContentApplySize', (showcaseSize) => {
    const calcWidth = $ctrl.extContentCalcWidth(showcaseSize.height)
    const calcHeight = $ctrl.extContentCalcHeight(showcaseSize.width)

    const fillHor = inRange(showcaseSize.width - calcWidth, 0, 30)
    const fillVer = inRange(showcaseSize.height - calcHeight, 0, 30)
    const useWidth = (fillHor || fillVer) ? fillHor : (calcHeight < showcaseSize.height)

    const width = useWidth ? showcaseSize.width : 'auto'
    const height = !useWidth ? showcaseSize.height : 'auto'
    const marginTop = useWidth ? Math.round((showcaseSize.height - calcHeight) / 2) : 0
    const marginLeft = !useWidth ? Math.round((showcaseSize.width - calcWidth) / 2) : 0

    $ctrl.contentSize = { width, height, marginTop, marginLeft }
    $ctrl.contentSizeEmitter.emit()
  })

  // <img-queue/>

  $ctrl.wrapH('thumbLoadDoneHandler', (thumbSize) => {
    $ctrl.thumbSize = thumbSize
    return $ctrl.callContentReadyHandler()
  })

  $ctrl.wrapH('thumbLoadFailHandler', () => {
    $ctrl.thumbFailed = true
    return $ctrl.callContentReadyHandler()
  })
}
